import { render } from "./FavViewModal.vue?vue&type=template&id=1a524080&scoped=true"
import script from "./FavViewModal.vue?vue&type=script&lang=js"
export * from "./FavViewModal.vue?vue&type=script&lang=js"

import "./FavViewModal.vue?vue&type=style&index=0&id=1a524080&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a524080"]])

export default __exports__